// extracted by mini-css-extract-plugin
export default {"container":"SimplifiedFeedback_container__IPS8Y","content":"SimplifiedFeedback_content__rzlKu"};